const FolderExportFilled = (props: React.ComponentProps<'svg'>) => (
    <svg xmlns={'http://www.w3.org/2000/svg'} width={'1em'} height={'1em'} viewBox={'0 0 24 24'} {...props}>
        <path fill={'currentColor'} d={'M1 2.5h8.48l2 2.5H23v8.846A6.5 6.5 0 0 0 12.232 21H1z'} />
        <path fill={'currentColor'} d={'m23.908 18.002l-4.858-4.914l-1.422 1.406l2.48 2.508h-7.11v2h7.11l-2.48 2.508l1.422 1.406z'} />
    </svg>
);
export default FolderExportFilled;
